<template>
    <v-dialog
        :value="showDialog"
        persistent
        max-width="550"
    >        
      <v-card>
        <v-card-title class="text-h5 yellow darken-3 white--text">Undeliverable Address</v-card-title>
        <v-card-text dark class='text-center'>
            <p>You've provided an undeliverable USPS address.</p>
            <p> Are you sure you want to continue?</p>
            <div class='d-flex flex-column align-center justify-center'>
              <span v-text="addressObject.oma_street_address1"></span>
              <span v-text="addressObject.oma_street_address2" v-if="addressObject.oma_street_address2"></span>
              <span v-text="`${addressObject.oma_city}, ${addressObject.oma_state} ${addressObject.oma_zip}`"></span>
            </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="gray darken-1"
            text
            @click="$emit('close-dialog')"
          >
            Change Address
          </v-btn>   
          <v-btn
            color="blue darken-1"
            text
            @click="$emit('override-address')"
          >
            This address is correct
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: 'InvalidAddressDialog',
    props: {
        showDialog: Boolean,
        addressObject:  Object
    },
    methods:{
    }
  }
</script>